export enum BackgroundMode {
    SOLID, GRADIENT, IMAGE
}
